// styles
require('../style.css')
require('../components/feature/style.css')
require('../components/row/style.css')
require('../components/view/style.css')
require('../components/title/style.css')
require('../components/space/style.css')
require('../components/buttonSet/style.css')
require('../components/header/style.css')
require('../components/header/style-fm.css')
require('../components/simple-header/style.css')
require('../components/feature/style.css')
require('../components/feature/style-fm.css')
require('../components/header-polaroid/style.css')
require('../components/header-polaroid/style-fm.css')
require('../components/text/style.css')
require('../components/link-dashboard/style.css')
require('../components/link-dashboard/style-fm.css')
require('../components/orbit/style.css')
require('../components/orbit/style-fm.css')
require('../components/thumbnail/style.css')
require('../components/card/style.css')
require('../components/footer-sitemap/style.css')
require('../components/footer-simplemap/style.css')
require('../components/footer-social/style.css')
require('../components/image/style.css')
require('../components/contact/style.css')
require('../components/image-full/style.css')
require('../components/links-list/style.css')
require('../components/testimonial/style.css')
require('../components/testimonial/style-fm.css')
require('../components/testimonial-full/style.css')
require('../components/testimonial-full/style-fm.css')
require('../components/mediaobject/style.css')
require('../components/marketing-section/style.css')
require('../components/marketing-section/style-fm.css')
require('../components/full-marketing-section/style.css')
require('../components/full-marketing-section/style-fm.css')
require('../components/buttons/style.css')
require('../components/video-link/style.css')
require('../components/simple-audio/style.css')
require('../components/album-audio/style.css')
require('../components/album-audio-list/style.css')
require('../components/circle-header/style.css')
require('../components/circle-header/style-fm.css')
require('../components/progress/style.css')
require('../components/progress/style-fm.css')
require('../components/image-link/style.css')
require('../components/images-patchwork/style.css')
require('../components/custom/style.css')

// *** lib
require('./initRuntime')
// require('./equalize')
require('../components/orbit/orbit')

/*import init from './initRuntime'
import equalize from './equalize'
import orbitUtilities from '../components/orbit/orbit'*/

// *** fix interchnage that does not work at start
$(document).ready(() => {
  window.requestAnimationFrame(() => $(window).trigger('resize'))
})



// WEBPACK FOOTER //
// src/runtime.js